// Email activity's words for our template keys and delivery statuses
// (rapid-api-core notify-email templates.go / status.go).

const TEMPLATE_LABELS = {
  invite: 'Invitation',
  invite_sso: 'Invitation (single sign-on)',
  invite_pin: 'Invitation with PIN',
  invite_accepted: 'Invitation accepted',
  password_reset: 'Password reset',
  password_changed: 'Password changed',
  register_confirm: 'Confirm registration',
  register_complete: 'Registration complete',
  contact_us: 'Contact us',
  log_error: 'Server error alert',
  sso_credential_expiry: 'SSO credential expiry',
  sso_domain_alert: 'Domain verification alert',
  sso_consent_request: 'SSO approval request',
  sso_consent_result: 'SSO approval result',
  org_deletion_scheduled: 'Organization scheduled for deletion',
  org_deletion_reminder: 'Organization deletion reminder',
  org_deletion_purge_now: 'Organization deleted today',
  org_deletion_purged: 'Organization permanently deleted',
  org_deletion_restored: 'Organization restored',
  org_deletion_member_notice: 'Organization deletion notice to members',
  org_deletion_member_restored: 'Organization restored notice to members',
  org_support_alert: 'Organization needs support',
  error_alert: 'Error alert',
  error_summary: 'Daily error summary',
  staff_alert: 'Staff alert',
  legacy: 'Other email'
}

export const templateLabel = key => TEMPLATE_LABELS[key] || key || 'Unknown'

const STATUS = {
  queued: { label: 'Queued', tone: null },
  sent: { label: 'Sent', tone: 'info' },
  deferred: { label: 'Deferred', tone: 'warn' },
  delivered: { label: 'Delivered', tone: 'ok' },
  opened: { label: 'Opened', tone: 'ok' },
  clicked: { label: 'Clicked', tone: 'ok' },
  unsubscribed: { label: 'Unsubscribed', tone: 'warn' },
  bounced: { label: 'Bounced', tone: 'bad' },
  dropped: { label: 'Dropped', tone: 'bad' },
  spam_report: { label: 'Marked as spam', tone: 'bad' },
  failed: { label: 'Failed', tone: 'bad' },
  other: { label: 'Other', tone: null }
}

export const statusLabel = status => (STATUS[status] ? STATUS[status].label : status || 'Unknown')
export const statusTone = status => (STATUS[status] ? STATUS[status].tone : null)

// What each status means, for a person deciding what to do about it.
const STATUS_MEANING = {
  deferred: 'The receiving server asked to try again later. The provider keeps retrying for a while.',
  bounced: 'The receiving server refused it. Check the address, or ask the person whether their organization blocks outside email.',
  dropped: 'The provider did not send it, usually because the address bounced or unsubscribed before.',
  spam_report: 'The recipient marked it as spam. Further email to them may not be delivered.',
  failed: 'It could not be handed to the provider. The error says why.'
}

export const statusMeaning = status => STATUS_MEANING[status] || ''

export const PROVIDER_LABELS = { sendgrid: 'SendGrid', catcher: 'Dev catcher (not sent)', dry_run: 'Dry run (not sent)' }
export const providerLabel = p => PROVIDER_LABELS[p] || p || ''
